import type { FaireProductEntity } from "../../entity_types/product";

export const p_qksypy2k78: FaireProductEntity = {
  token: "p_qksypy2k78",
  type: "product",
  name: "Kit Kat Japan Chocolate Orange Minis 4 oz 6 Bags",
  brandToken: "b_et6a66kd2z",
  brandName: "Long Island Candy Factory",
  imageUrl:
    "https://cdn.faire.com/fastly/58c38873c1a478da79dbf91a21b84f9b6146fea34095fb41fd85050caf1966ab.jpeg",
  galleryImageUrls: [],
  priceDollars: 41.56,
  description:
    "Citrus and chocolate are a delightful flavor combination you can explore with this Japanese Kit Kat Orange Chocolate! Each chocolate features crispy wafers and a delicious orange chocolate flavor that makes them irresistible. With nine individual portions, this pack is perfect for sharing or enjoying on the go.",
  tags: [],
  msrpDollars: 83.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:16.784Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
